<template>
	<th :style="[styleWidth]" :class="[`text-${col.align ? col.align : 'left'}`]">
		<div
			class="flex"
			:class="[checkShowTooltip ? 'items-center justify-center' : '']"
		>
			<span
				class="ms-th-title"
				:class="[checkShowTooltip ? 'flex-none' : 'flex-1']"
				>{{ col.title }}</span
			>
			<div
				class="mi-new mi-16 mi-info-blue-16 ml-1 cusor-pointer"
				v-if="checkShowTooltip"
				v-tooltip="col.tooltip.text"
			></div>
			<div class="ms-resize" @mousedown="resizeOn"></div>
		</div>
	</th>
</template>
<script>
export default {
	name: 'msTh',
	props: {
		col: {},
		colIndex: {
			default: 0,
			type: Number,
		},
	},
	created() {
		const me = this;
		me.widthx = me.col.width;
		me.autoResizex = me.col.autoResize;
	},
	computed: {
		styleWidth() {
			const me = this;
			if (me.autoResizex) {
				return {
					'min-width': me.widthx + 'px',
				};
			}
			return {
				width: me.widthx + 'px',
				'min-width': me.widthx + 'px',
			};
		},

		checkShowTooltip() {
			const me = this;
			return me.col && me.col.tooltip && me.col.tooltip.isShow;
		},
	},
	watch: {
		cursorX() {
			let offsetX = this.resizeX - this.cursorX;
			this.widthx = this.defaultwidth - offsetX;
		},
	},
	data() {
		return {
			cursorX: 0,
			widthx: 0,
			autoResizex: false,
		};
	},
	methods: {
		//Bắt đầu co kéo cột
		resizeOn(event) {
			const me = this;
			this.$nextTick(() => {
				this.defaultwidth = this.$el.offsetWidth;
			});
			this.resizeX = event.screenX;
			me.$emit('resizeOn', this.col);
			document.addEventListener('mousemove', this.mousemove);
		},
		//Di chuyển co kéo cột
		mousemove(e) {
			const me = this;
			me.cursorX = e.screenX;
			me.$emit('resizeMove', this.col);
			if (!me.isResizeActive) {
				me.isResizeActive = true;
				document.addEventListener('mouseup', me.resizeOff);
			}
		},
		//Ngừng co kéo cột
		resizeOff() {
			const me = this;
			me.col.width = me.$el.offsetWidth;
			me.$emit('resizeOff', me.col);
			document.removeEventListener('mousemove', me.mousemove);
			me.closeResizeOff();
			me.isResizeActive = false;
		},
		closeResizeOff() {
			document.removeEventListener('mouseup', this.resizeOff);
		},
		//Update lại động rộng của cột
		updateColWidth() {
			const me = this;
			if (me.$el) {
				me.widthx = me.$el.offsetWidth;
				me.autoResizex = false;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}
</style>